Drupal.behaviors.kinaxisLogosSlider = {
  attach(context) {
    const marqueeSlider = context.classList && context.classList.contains('paragraph--type--logos-extend')
      ? [context] : context.querySelectorAll('.paragraph--type--logos-extend');
    if (!marqueeSlider) { return; }

    marqueeSlider.forEach((element) => {
      // General variables.
      const slider = element.querySelector('.logos-slider');
      if (slider) {
        const items = slider.querySelectorAll('.logo-item');
        let itemsWidth = 0;
        items.forEach( (item) => {
          itemsWidth = itemsWidth + item.offsetWidth;
        });

        slider.setAttribute('style', `width: ${itemsWidth}px`);

        // Css variable.
        const css = window.document.styleSheets[0];

        css.insertRule(`
        @keyframes scroll {
          0%   { transform: translateX(0px); }
          100% { transform: translateX(${-itemsWidth + window.innerWidth}px); }
        }`, css.cssRules.length);

        slider.style.animation = 'scroll 80s linear infinite';
      }
    });
  },
};
